import React, { useEffect, useRef, useState } from 'react';

// Parses a value like "10+", "500+", "98%" into { number, suffix }
const parseValue = (value) => {
  const match = String(value).match(/^(\d+(?:\.\d+)?)(.*)$/);
  if (!match) return { number: 0, suffix: String(value), decimals: 0 };
  const numStr = match[1];
  const decimals = numStr.includes('.') ? numStr.split('.')[1].length : 0;
  return { number: parseFloat(numStr), suffix: match[2], decimals };
};

const CountUp = ({ value, duration = 1800, className = '' }) => {
  const { number, suffix, decimals } = parseValue(value);
  const [display, setDisplay] = useState(0);
  const ref = useRef(null);
  const startedRef = useRef(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !startedRef.current) {
            startedRef.current = true;
            const startTime = performance.now();
            const tick = (now) => {
              const progress = Math.min((now - startTime) / duration, 1);
              // easeOutCubic for a natural finish
              const eased = 1 - Math.pow(1 - progress, 3);
              setDisplay(number * eased);
              if (progress < 1) requestAnimationFrame(tick);
              else setDisplay(number);
            };
            requestAnimationFrame(tick);
          }
        });
      },
      { threshold: 0.4 }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [number, duration]);

  return (
    <span ref={ref} className={className}>
      {display.toFixed(decimals)}{suffix}
    </span>
  );
};

export default CountUp;
